// import React, { useEffect, useState } from "react";
// import CustomTable from "../../../Components/Table/CustomTable";

// import { Grid } from "@mui/material";

// import UserRoleCreateModal from "../Modal/UserRoleCreateModal";
// import AllUserListCreateModal from "../Modal/UserListCreateModal";
// import actions from "../../../ReduxStore/actions/index";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   setHeaderName,
//   setSubHeaderName,
// } from "../../../ReduxStore/Slices/headerSlice";

// const UserList = () => {
//   const dispatch = useDispatch();

//   const { multiUserCreation } = useSelector(
//     (state) => state?.multiUserCreation
//   );

//   const tableData = [
//     {
//       Name: "Vallarasu",
//       Email: "valla@gmail.com",
//       MobileNumber: "1232343444",
//       UserRole: "Admin",
//       Status: "Active",
//     },
//     {
//       Name: "Pravin",
//       Email: "pravin@gmail.com",
//       MobileNumber: "98787687687",
//       UserType: "Super Admin",
//       Status: "Active",
//     },
//     {
//       Name: "Shahul",
//       Email: "shahul@gmail.com",
//       MobileNumber: "123322443543",
//       UserType: "Opeartor",
//       Status: "Active",
//     },
//     {
//       Name: "Ramesh",
//       Email: "Ramesh@gmail.com",
//       MobileNumber: "76575675664",
//       UserType: "Admin",
//       Status: "Active",
//     },
//     {
//       Name: "Sanjeev",
//       Email: "Sanjeev@gmail.com",
//       MobileNumber: "909878789709",
//       UserType: "Super Admin",
//       Status: "Active",
//     },
//   ];
//   const tableHeadData = [
//     "S.No",
//     "Name",
//     "User ID",
//     "Email",
//     "Mobile Number",
//     "User Role",
//     "Status",
//   ];

//   const { getAllUserWithRole } = useSelector(
//     (state) => state?.getAllUserWithRole
//   );

//   console.log(
//     getAllUserWithRole?.data,
//     "getAllCustomersStatusgetAllCustomersStatus"
//   );

//   useEffect(() => {
//     const fetchData = async () => {
//       const data1 = { data: {}, method: "get", apiName: `getAllAuthUser` };
//       await dispatch(actions.GETALLUSERWITHROLE(data1));
//     };
//     fetchData();
//   }, [dispatch, multiUserCreation]);




//   const [rowTableData, setRowTableData] = useState([
//     {
//       name: "--",
//       operator_id: "--",
//       email: "--",
//       phone: "--",
//       userRole: "--",
//       Status: "--",
//     },
//   ]);

//   useEffect(() => {
//     const tempArr = [];
//     getAllUserWithRole?.data?.map((data, index) => {
//       return tempArr.push({
//         name: `${data?.name}`,
//         user_id: data?.user_id,
//         email: data?.email,
//         phone: data?.phone,
//         userRole: data?.userRole,
//         Status: data?.delete_status === 0 ? "Active" : "Inactive",
//       });
//     });
//     setRowTableData(tempArr);
//   }, [dispatch, getAllUserWithRole, multiUserCreation]);










//   React.useEffect(() => {
//     dispatch(setHeaderName("Master"));
//     dispatch(setSubHeaderName("User List"));
//   }, [dispatch]);

//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sx={{ width: "100px" }}>
//         <CustomTable
//           tableData={rowTableData}
//           title="User List"
//           tableHeadData={tableHeadData}
//           modalName={AllUserListCreateModal}
//           modalHeadingName="Create User"
//           tableEdit="tableEdit"
//           tableDelete="tableDelete"
//         />
//       </Grid>
//     </Grid>
//   );
// };

// export default UserList;

import React, { useEffect, useState } from "react";
import CustomTable from "../../../Components/Table/CustomTable";

import { Grid } from "@mui/material";

import UserRoleCreateModal from "../Modal/UserRoleCreateModal";
import AllUserListCreateModal from "../Modal/UserListCreateModal";
import actions from "../../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeaderName,
  setSubHeaderName,
} from "../../../ReduxStore/Slices/headerSlice";
import { toast } from "react-toastify";

const UserList = () => {
  const dispatch = useDispatch();

  const { multiUserCreation } = useSelector(
    (state) => state?.multiUserCreation
  );

  const { updateAuthUser } = useSelector(
    (state) => state?.updateAuthUser
  );

  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserRole: "Admin",
      Status: "Active",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Super Admin",
      Status: "Active",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Opeartor",
      Status: "Active",
    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      MobileNumber: "76575675664",
      UserType: "Admin",
      Status: "Active",
    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      MobileNumber: "909878789709",
      UserType: "Super Admin",
      Status: "Active",
    },
  ];
  const tableHeadData = [
    "S.No",
    "Name",
    // "User ID",
    "Email Id",
    "Mobile Number",
    "User Role",
    "Status",
  ];

  const { getAllUserWithRole } = useSelector(
    (state) => state?.getAllUserWithRole
  );

  console.log(
    getAllUserWithRole?.data,
    "getAllCustomersStatusgetAllCustomersStatus"
  );


  const { softDeleteAuthUser } = useSelector(
    (state) => state?.softDeleteAuthUser
  );

  useEffect(() => {
    const fetchData = async () => {
      const data1 = { data: {}, method: "get", apiName: `getAllAuthUser` };
      await dispatch(actions.GETALLUSERWITHROLE(data1));
    };
    fetchData();
  }, [dispatch, multiUserCreation, updateAuthUser, softDeleteAuthUser]);




  const [rowTableData, setRowTableData] = useState([
    {
      name: "--",
      operator_id: "--",
      email: "--",
      phone: "--",
      userRole: "--",
      Status: "--",
    },
  ]);

  useEffect(() => {
    const tempArr = [];
    getAllUserWithRole?.data?.map((data, index) => {
      return tempArr.push({
        name: `${data?.name}`,
        user_id: data?.user_id,
        email: data?.email,
        phone: data?.phone,
        userRole: data?.role?.roleName,
        Status: data?.delete_status === 0 ? "Active" : "Inactive",
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getAllUserWithRole, multiUserCreation, updateAuthUser]);

 

  const handleTableDataDelete = async(id) => {


    const data1 = {
      data: {},
      method: "delete",
      apiName: `softDeleteAuthUser/${id}`,
    };
    const responseData = await dispatch(actions.SOFTDELETEAUTHUSER(data1));
    if (responseData?.payload?.message === "User deleted successfully (soft delete).") {
      toast.success("User soft delete sucessfully!")
    } else {
      toast.error(responseData?.payload?.message)

    }
    }




    const customerId = useSelector((state) => state.customer.customerId);
    const TableId = useSelector((state) => state.Table.TableId);


    console.log(customerId, "customerIddd")
    React.useEffect(() => {
      dispatch(setHeaderName("Master"));
      dispatch(setSubHeaderName("User List"));
    }, [dispatch]);

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ width: "100px" }}>
          <CustomTable
            tableData={rowTableData}
            title="User List"
            tableHeadData={tableHeadData}
            modalName={AllUserListCreateModal}
            editModalName={AllUserListCreateModal}
            modalHeadingName="Create User"
            tableEdit="tableEdit"
            tableDelete="tableDelete"
            dataCreate={true}
            handleTableDataDelete={handleTableDataDelete}
          />
        </Grid>
      </Grid>
    );
  };

  export default UserList;
